/* global axios */
import ApiClient from './ApiClient';

class KraftchatBillingAPI extends ApiClient {
  constructor() {
    super('kraftchat_billing', { accountScoped: true });
  }

  createCheckoutSession({ planKey, billingCycle }) {
    return axios.post(`${this.url}/checkout_session`, {
      plan_key: planKey,
      billing_cycle: billingCycle,
    });
  }

  changeSubscription({ planKey, billingCycle }) {
    return axios.patch(`${this.url}/subscription`, {
      plan_key: planKey,
      billing_cycle: billingCycle,
    });
  }

  cancelSubscription() {
    return axios.delete(`${this.url}/subscription`);
  }

  undoCancellation() {
    return axios.post(`${this.url}/subscription/undo_cancellation`);
  }
}

export default new KraftchatBillingAPI();
